import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import StatueSilhouette from "@/components/StatueSilhouette";

const Cancel = () => {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white flex flex-col">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 flex items-center justify-center z-0"
      >
        <StatueSilhouette className="text-yellow opacity-[0.05] h-[110vh] w-auto" />
      </div>

      <div className="relative z-10 flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-xl text-center">
          <XCircle className="h-14 w-14 text-yellow mx-auto" strokeWidth={2} />
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-yellow mt-6">
            Checkout Cancelled
          </div>
          <h1 className="font-display text-5xl sm:text-7xl mt-3 leading-[0.9]" data-testid="cancel-title">
            NO <span className="text-yellow">CHARGE</span>.
          </h1>
          <p className="text-[#d4d4d8] mt-5">
            Your card wasn't charged. Whenever you're ready to start, the Blueprint is still here.
          </p>
          <Link to="/" className="btn-brutal mt-8" data-testid="cancel-back-home">
            <ArrowLeft className="h-5 w-5" /> Back to Blueprint
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
